module.exports = __webpack_public_path__ + "img/fejlec_kep_egyben_up_1920.e2bfd77a.png";